import React, { ReactNode } from "react";
import ErrorFallBack from "./ErrorFallBack";
import { addReactError } from "@datadog/browser-rum-react";

class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    addReactError(error, errorInfo);
  }

  render(): JSX.Element | ReactNode {
    if (this.state.hasError)
      return <ErrorFallBack className={this.props.fallbackClassName} />;
    return this.props.children;
  }
}

export default ErrorBoundary;
